import {Chip} from 'platform/components';
import {HStack, Stack, Text} from 'platform/foundation';

import {isNil} from 'ramda';

import i18n from '../../../../../i18n/i18n';

interface TwoWayPropertyChipsProps {
  label: string;
  /** null = any */
  value: 'same' | null;
  onChange: (next: 'same' | null) => void;
  isReadOnly?: boolean;
}

export function TwoWayPropertyChips(props: TwoWayPropertyChipsProps) {
  return (
    <Stack
      direction={['column', 'row']}
      align={[undefined, 'center']}
      justify="space-between"
      spacing={2}
    >
      <Text size="small">{props.label}</Text>
      <HStack spacing={1}>
        <Chip
          label={i18n.t('entity.filterForm.savedFilters.mode.same')}
          value={props.value === 'same'}
          onChange={() => props.onChange('same')}
          size="small"
          isDisabled={props.isReadOnly}
        />
        <Chip
          label={i18n.t('entity.filterForm.savedFilters.mode.any')}
          value={isNil(props.value)}
          onChange={() => props.onChange(null)}
          size="small"
          isDisabled={props.isReadOnly}
        />
      </HStack>
    </Stack>
  );
}
